import { useRef, useEffect } from 'react'
import { useFrame, useLoader } from '@react-three/fiber'

import { TextureLoader } from 'three/src/loaders/TextureLoader'
import { Mesh } from 'three'

import GlowMesh from './glow-mesh'

const Earth = function (props: any) {
  const earthMesh = useRef<Mesh>(null)

  useEffect(() => {
    // ..
  }, [])

  useFrame((state, delta) => {
    // earthMesh.current.rotation.y += 0.01
  })

  const [textureMap, textureNormalMap, textureSpecMap] = useLoader(
    TextureLoader,
    [
      `${process.env.PUBLIC_URL}/assets/earth.jpg`,
      `${process.env.PUBLIC_URL}/assets/earth_normal.jpg`,
      `${process.env.PUBLIC_URL}/assets/earth_spec.jpg`,
    ]
  )

  return (
    <mesh {...props} ref={earthMesh}>
      <sphereGeometry args={[3.75, 40, 40]}></sphereGeometry>
      <meshStandardMaterial
        map={textureMap}
        normalMap={textureNormalMap}
        metalnessMap={textureSpecMap}
        roughness={0.7}
        metalness={0.4}
        attach={'material'}
      ></meshStandardMaterial>
      <GlowMesh scale={[1.2, 1.2, 1.2]}></GlowMesh>
    </mesh>
  )
}

export default Earth
